var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 26",
    id: "sh-icon-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.89 17.364l3.535 3.535",
    stroke: "#00A0AF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.525,
    cy: 11,
    r: 7,
    transform: "rotate(-45 11.525 11)",
    stroke: "#00A0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99 14.536a5 5 0 010-7.072",
    stroke: "#00A0AF",
    strokeLinecap: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    id: "sh-icon-person"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 2,
    r: 1.35,
    stroke: "#00A0AF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12v-1.16C11 8.167 8.761 6 6 6s-5 2.167-5 4.84V12",
    stroke: "#00A0AF",
    strokeWidth: 1.3
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 15",
    id: "sh-icon-location"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.977a49.883 49.883 0 01-2.215-2.957c-.679-.985-1.347-2.05-1.844-3.044C.933 6.958.65 6.1.65 5.5a4.85 4.85 0 019.7 0c0 .6-.283 1.458-.791 2.476-.497.994-1.165 2.06-1.844 3.044A49.417 49.417 0 015.5 13.977z",
    stroke: "#00A0AF",
    strokeWidth: 1.3
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14",
    id: "sh-icon-company"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14V1l9 1.733V14M5 6L1 7.412V14",
    stroke: "#00A0AF",
    strokeWidth: 1.3
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    id: "sh-icon-hidden"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4274 17C22.4171 24.3217 11.5829 24.3217 6.57261 17C11.5829 9.67829 22.4171 9.67829 27.4274 17Z",
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3.5,
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 7L8 26",
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    id: "sh-icon-visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4274 17C22.4171 24.3217 11.5829 24.3217 6.57261 17C11.5829 9.67829 22.4171 9.67829 27.4274 17Z",
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3.5,
    stroke: "#6A6A6A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    id: "sh-icon-zoomin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 1C21.5 0.723858 21.2761 0.5 21 0.5H16.5C16.2239 0.5 16 0.723858 16 1C16 1.27614 16.2239 1.5 16.5 1.5H20.5V5.5C20.5 5.77614 20.7239 6 21 6C21.2761 6 21.5 5.77614 21.5 5.5V1ZM13.3536 9.35355L21.3536 1.35355L20.6464 0.646447L12.6464 8.64645L13.3536 9.35355Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21.5C21.2761 21.5 21.5 21.2761 21.5 21L21.5 16.5C21.5 16.2239 21.2761 16 21 16C20.7239 16 20.5 16.2239 20.5 16.5L20.5 20.5L16.5 20.5C16.2239 20.5 16 20.7239 16 21C16 21.2761 16.2239 21.5 16.5 21.5L21 21.5ZM12.6464 13.3536L20.6464 21.3536L21.3536 20.6464L13.3536 12.6464L12.6464 13.3536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21C0.500001 21.2761 0.723858 21.5 1 21.5L5.5 21.5C5.77614 21.5 6 21.2761 6 21C6 20.7239 5.77614 20.5 5.5 20.5L1.5 20.5L1.5 16.5C1.5 16.2239 1.27614 16 1 16C0.723857 16 0.5 16.2239 0.5 16.5L0.5 21ZM8.64645 12.6464L0.646447 20.6464L1.35355 21.3536L9.35355 13.3536L8.64645 12.6464Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5C0.723857 0.500001 0.5 0.723858 0.5 1L0.5 5.5C0.5 5.77614 0.723858 6 1 6C1.27614 6 1.5 5.77614 1.5 5.5L1.5 1.5L5.5 1.5C5.77614 1.5 6 1.27614 6 1C6 0.723858 5.77614 0.5 5.5 0.5L1 0.5ZM9.35355 8.64645L1.35355 0.646447L0.646446 1.35355L8.64645 9.35355L9.35355 8.64645Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    id: "sh-icon-zoomout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9C12.5 9.27614 12.7239 9.5 13 9.5L17.5 9.5C17.7761 9.5 18 9.27614 18 9C18 8.72386 17.7761 8.5 17.5 8.5L13.5 8.5L13.5 4.5C13.5 4.22386 13.2761 4 13 4C12.7239 4 12.5 4.22386 12.5 4.5L12.5 9ZM20.6464 0.646446L12.6464 8.64645L13.3536 9.35355L21.3536 1.35355L20.6464 0.646446Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5C12.7239 12.5 12.5 12.7239 12.5 13L12.5 17.5C12.5 17.7761 12.7239 18 13 18C13.2761 18 13.5 17.7761 13.5 17.5L13.5 13.5L17.5 13.5C17.7761 13.5 18 13.2761 18 13C18 12.7239 17.7761 12.5 17.5 12.5L13 12.5ZM21.3536 20.6464L13.3536 12.6464L12.6464 13.3536L20.6464 21.3536L21.3536 20.6464Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50391 13C9.50391 12.7239 9.28005 12.5 9.00391 12.5L4.50391 12.5C4.22776 12.5 4.00391 12.7239 4.00391 13C4.00391 13.2761 4.22776 13.5 4.50391 13.5L8.50391 13.5L8.5039 17.5C8.5039 17.7761 8.72776 18 9.0039 18C9.28005 18 9.50391 17.7761 9.50391 17.5L9.50391 13ZM1.35746 21.3536L9.35746 13.3536L8.65035 12.6464L0.650351 20.6464L1.35746 21.3536Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5C9.27614 9.5 9.5 9.27614 9.5 9L9.5 4.5C9.5 4.22386 9.27614 4 9 4C8.72386 4 8.5 4.22386 8.5 4.5L8.5 8.5L4.5 8.5C4.22386 8.5 4 8.72386 4 9C4 9.27614 4.22386 9.5 4.5 9.5L9 9.5ZM0.646446 1.35355L8.64645 9.35355L9.35355 8.64645L1.35355 0.646447L0.646446 1.35355Z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 20",
    id: "sh-icon-hesburger"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 1L1 1",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 7L1 7",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 13L1 13",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 19L19 19",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    id: "sh-icon-close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L11 11",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1L1 11",
    stroke: "currentColor"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    x: 4,
    y: 5,
    viewBox: "0 0 24 24",
    id: "sh-icon-sort"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9766 1L11.9766 13",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94714 9.93933L12.0078 13L15.0685 9.93933",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13L4 2",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12317 4.43933L4.0625 1.37866L1.00183 4.43933",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    x: 3,
    y: 7,
    viewBox: "0 0 24 24",
    id: "sh-icon-filter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9L5 9",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5L3 5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1L1 1",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sh-icon-warning",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.408 7.152C10.6747 7.152 10.9013 7.056 11.088 6.864C11.28 6.672 11.376 6.44267 11.376 6.176C11.376 5.90933 11.28 5.68267 11.088 5.496C10.9013 5.304 10.6747 5.208 10.408 5.208C10.1413 5.208 9.912 5.304 9.72 5.496C9.53333 5.68267 9.44 5.90933 9.44 6.176C9.44 6.44267 9.53333 6.672 9.72 6.864C9.912 7.056 10.1413 7.152 10.408 7.152ZM9.632 17H11.184V8.808H9.632V17Z",
    fill: "#FCA01F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 10,
    stroke: "#FCA01F"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60.364 60.364",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sh-icon-plus",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.454,23.18l-18.609-0.002L35.844,5.91C35.845,2.646,33.198,0,29.934,0c-3.263,0-5.909,2.646-5.909,5.91v17.269 L5.91,23.178C2.646,23.179,0,25.825,0,29.088c0.002,3.264,2.646,5.909,5.91,5.909h18.115v19.457c0,3.267,2.646,5.91,5.91,5.91 c3.264,0,5.909-2.646,5.91-5.908V34.997h18.611c3.262,0,5.908-2.645,5.908-5.907C60.367,25.824,57.718,23.178,54.454,23.18z",
    fill: "#00A0AF"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 52.161 52.161",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sh-icon-minus",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.161,26.081c0,3.246-2.63,5.875-5.875,5.875H5.875C2.63,31.956,0,29.327,0,26.081l0,0c0-3.245,2.63-5.875,5.875-5.875 h40.411C49.531,20.206,52.161,22.835,52.161,26.081L52.161,26.081z",
    fill: "#00A0AF"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 9",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sh-icon-caret",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0711 1.07107L8 8.14214L0.928932 1.07107",
    stroke: "#262626"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 378 378",
    xmlns: "http://www.w3.org/2000/svg",
    id: "sh-icon-question",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A0AF"
    },
    d: "M151.483,302.967C67.956,302.967,0,235.017,0,151.483S67.956,0,151.483,0 s151.483,67.956,151.483,151.483S235.017,302.967,151.483,302.967z M151.483,24.416c-70.066,0-127.067,57.001-127.067,127.067 s57.001,127.067,127.067,127.067s127.067-57.001,127.067-127.067S221.555,24.416,151.483,24.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A0AF"
    },
    d: "M116.586,118.12c1.795-4.607,4.297-8.588,7.511-11.961c3.225-3.389,7.114-6.016,11.667-7.898 c4.547-1.904,9.633-2.845,15.262-2.845c7.261,0,13.32,0.995,18.183,2.997c4.857,1.996,8.768,4.482,11.738,7.441 c2.964,2.97,5.091,6.168,6.369,9.584c1.273,3.432,1.915,6.636,1.915,9.595c0,4.901-0.642,8.947-1.915,12.118 c-1.278,3.171-2.866,5.88-4.759,8.131c-1.898,2.252-3.987,4.172-6.293,5.755c-2.295,1.588-4.471,3.171-6.516,4.759 c-2.045,1.583-3.862,3.394-5.445,5.439c-1.588,2.04-2.589,4.601-2.991,7.664v5.831H140.6v-6.908 c0.305-4.395,1.153-8.072,2.529-11.036c1.382-2.964,2.991-5.499,4.83-7.598c1.844-2.089,3.786-3.911,5.836-5.445 c2.04-1.539,3.927-3.073,5.673-4.591c1.73-1.545,3.144-3.225,4.221-5.069c1.071-1.833,1.556-4.15,1.452-6.908 c0-4.705-1.148-8.18-3.454-10.427c-2.295-2.257-5.493-3.378-9.589-3.378c-2.758,0-5.134,0.533-7.131,1.605 s-3.628,2.513-4.911,4.302c-1.278,1.795-2.225,3.894-2.834,6.288c-0.615,2.415-0.919,4.982-0.919,7.756h-22.55 C113.85,127.785,114.791,122.732,116.586,118.12z M162.536,183.938v23.616h-24.09v-23.616H162.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.7125f3d07bd1aba5ba085a852559e436.svg";
export { ForwardRef as ReactComponent };